exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-booking[data-v-1b96c6c9]{color:var(--blue)}.booking-term-modal-body ol[data-v-1b96c6c9],.booking-term-modal-body ul[data-v-1b96c6c9]{list-style:initial;margin-block-start:1em;padding-inline-start:40px}.booking-term-modal-body ol li[data-v-1b96c6c9],.booking-term-modal-body ul li[data-v-1b96c6c9]{margin-bottom:.5rem}.booking-term-modal-body ol[data-v-1b96c6c9]{list-style-type:decimal}.booking-term-modal .zb-modal-title-container[data-v-1b96c6c9]{border-radius:4px;padding:.5rem 1rem;background:var(--blue-light-3)}.booking-term-modal .zb-modal-title-container .zb-modal-close[data-v-1b96c6c9]{padding:0}", ""]);

// exports
